module.exports = __webpack_public_path__ + "static/media/markAsStuck.25a821de.svg";